<template>
  <div class="live-guarantee-pool-container" v-loading="loading">
    <live-guarantee-search ref="search" @search="handelSearch">
      <live-guarantee-delete :get-selection="getSelection" @success="handelSearch"/>
      <el-button v-permission="'live_guarantee__un_confirm'"  icon="el-icon-remove" type="primary" style="background: #e03f3d;margin-left: 10px;"
                 @click="handleBatchUnConfirm">
        批量撤回确认
      </el-button>
    </live-guarantee-search>
    <div class="live-guarantee-pool-container__content default-table" :style="`height:${height_content}`">
      <div class="toolbar"
           style="display: flex;justify-content: space-between;align-items: center;position:absolute;z-index: 9;left: 80px;width: calc(100% - 110px);border-bottom: unset">
        <div>
          <el-radio-group v-model="search.status" size="mini" style="margin-right: 20px;">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">待确认</el-radio-button>
            <el-radio-button :label="2">已确认</el-radio-button>
          </el-radio-group>
          <span>共有&nbsp;{{ search.total }}&nbsp;直播保量数据</span>
          <el-tooltip
              content="总额度即目标投放金额。完成额度为对应签约时间区间内该客户/集团投放金额（含税收入）总和。"
              placement="right" effect="light">
                        <span style="color: #AAAAAA;margin-left: 10px;cursor: pointer;">数据说明<i
                            class="el-icon-info"/></span>
          </el-tooltip>
        </div>
        <toolbar-sort :fields="FieldsSort" @change="eventSort"/>
      </div>
      <el-table ref="table" :data="table" height="calc(100% - 42px)" class="live-guarantee-pool_table"
                style="width: 100%">
        <el-table-column type="selection" width="50" :selectable="selectable"/>
        <el-table-column>
          <template v-slot="{row:{date_live,artist_name,status,platform}}">
            <span v-if="MapStatus[status]"
                  class="tag"
                  :style="{color:MapStatus[status].color,background:MapStatus[status].bg_color}">
                {{ MapStatus[status].label }}
            </span>
            <div style="margin-top: 8px;">月份：<span>{{ date_live|parseTime('{y}年{m}月') }}</span></div>
            <div>红人昵称：<span>{{ artist_name }}</span></div>
            <div>平台：<span>{{ platform }}</span></div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{shop_name,product_name,source_traffic}}">
            <div>店铺：<span>{{ shop_name }}</span></div>
            <div>商品名称：<span>{{ product_name || '-' }}</span></div>
            <div>流量来源：<span>{{ source_traffic || '-' }}</span></div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{sales_volume,settlement_amount,commission_income,commission_rate}}">
            <div>订单数：<span>{{ sales_volume|numberFormat }}</span></div>
            <div>结算金额：<span>￥{{ settlement_amount|numberFormat(2) }}</span></div>
            <div>佣金收入：<span>￥{{ commission_income|numberFormat(2) }}</span></div>
            <div>佣金比例：<span>{{ commission_rate|numberFormat(2) }}%</span></div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{claim_or,claim_at,confirm_at,order_no}}">
            <div v-if="order_no">
              认领全案：
              <span><to-order-detail by-field="order_no" :order="{order_no}"/></span>
            </div>
            <div>认领归属：<span>{{ claim_or || '-' }}</span></div>
            <div>认领时间：<span>{{ claim_at|parseTime('{y}/{m}/{d} {h}:{i}') }}</span></div>
            <div>确认时间：<span>{{ confirm_at|parseTime('{y}/{m}/{d} {h}:{i}') }}</span></div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{date_check}}">
            <div style="text-align:center;font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
              <span v-if="date_check">{{ date_check|parseTime('{y}年{m}月') }}</span>
              <span v-else style="font-size: 14px;">暂未核算</span>
            </div>
            <div style="text-align:center;color: #AAAAAA;">核算月份</div>
          </template>
        </el-table-column>
        <el-table-column width="120" align="center">
          <template v-slot="{row:{id,status,date_check}}">
            <el-button v-permission="'live_guarantee__un_confirm'" v-if="status===StatusConfirm" size="small" round
                       @click="handleUnConfirm([id])" :disabled="date_check !== null && lockInfo.lock_at >= date_check">
              撤回确认
            </el-button>
            <el-button v-permission="'live_guarantee__cancel'" v-if="status===StatusWait" size="small" round
                       @click="handleCancel([id])">
              撤销
            </el-button>

          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px;display: flex;justify-content: space-between;align-items: center;">
        <div>
          <live-guarantee-confirm v-permission="'live_guarantee__confirm'" :get-selection="getSelection"
                                  @success="handelSearch"/>
        </div>

        <div style="display: flex;align-items: center;">
          <import-records module="live_guarantee_pool" @refresh="handelSearch" style="margin-right: 10px;"/>
          <el-pagination
              background
              :current-page="search.page"
              :page-sizes="[5,10,20,100, 200, 300, 400]"
              :page-size="search.page_size"
              layout="total, sizes, prev, pager, next"
              :total="search.total"
              style="float: right;"
              @current-change="handleCurrentChange"
              @size-change="eventSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolbarSort from "@/components/ToolbarSort/index.vue";
import {liveGuaranteeList} from "@/api/liveGuarantee";
import {MapStatus, FieldsSort, StatusClaim, StatusWait, StatusConfirm} from "./index";
import LiveGuaranteeSearch from "./component/search.vue";
import LiveGuaranteeConfirm from "./component/confirm.vue";
import {liveGuaranteeCancel, liveGuaranteeUnConfirm} from "../../../api/liveGuarantee";
import ImportRecords from "./component/import-records.vue";
import LiveGuaranteeDelete from "./component/delete.vue";
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";
import {liveGuaranteeLockGetLastLock} from "@/api/liveGuaranteeLock";

export default {
  name: "LiveGuaranteePool",
  components: {
    ToOrderDetail,
    LiveGuaranteeDelete,
    ImportRecords,
    LiveGuaranteeConfirm,
    LiveGuaranteeSearch,
    ToolbarSort
  },
  data() {
    return {
      StatusWait,
      StatusClaim,
      StatusConfirm,
      MapStatus,
      FieldsSort,
      table: [],
      height_content: 'calc(100% - 48px - 77px)',
      loading: false,
      search: {
        page: 1,
        page_size: 20,
        total: 0,
        order_by: null,
        status: ''
      },
      lockInfo: {}
    }
  },
  watch: {
    "search.status"(_) {
      this.$refs.search.search.status = _ + ''
      this.handelSearch()
    }
  },
  created() {
    this.init()
  },
  beforeMount() {
    window.addEventListener('resize', this.handelResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handelResize)
  },
  methods: {
    eventSizeChange: function (page_size) {
      this.search.page_size = page_size
      this.handelSearch()
    },
    handleBatchUnConfirm: function () {
      const data = this.getSelection()
      if (data.length < 1) {
        this.$message.warning('请选择要撤回确认的行！')
        return;
      }
      let error = false
      const ids = data.map(_ => {
        if (_.status !== StatusConfirm) {
          error = `${_.artist_name}，${_.shop_name} 没有确认！不可撤回确认`
        }
        return _.id
      })
      if (error) {
        this.$message.warning(error)
        return;
      }
      this.handleUnConfirm(ids)
    },
    handleUnConfirm: function (ids) {
      let tip = '确定撤回已确认状态吗?此操作后数据将变成（已认领，待确认）'
      if (ids.length > 1) {
        tip = `已选择${ids.length}行，确定把它们撤回已确认状态吗?此操作后数据将变成（已认领，待确认）`
      }
      this.$msgbox.confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {success} = await liveGuaranteeUnConfirm({ids})
        if (success) {
          this.$message.success('操作成功！')
          await this.handelSearch()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    handleCancel: function (ids) {
      this.$msgbox.confirm('确定撤销改数据吗？撤销后将不能再被认领', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {success} = await liveGuaranteeCancel({ids})
        if (success) {
          this.$message.success('操作成功！')
          await this.handelSearch()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    getSelection: function () {
      return this.$refs.table.selection
    },
    handelResize() {
      this.$nextTick(() => {
        const dom = this.$refs.search
        this.height_content = `calc(100% - 48px - ${dom.$el.offsetHeight}px - 10px)`
      })
    },
    init: function () {
      this.$nextTick(() => {
        this.getData()
        this.handelResize()
      })
    },
    handleCurrentChange: function (val) {
      this.search.page = val
      this.getData()
    },
    handelSearch: function () {
      this.search.page = 1
      this.getData()
    },
    eventSort: function (field, sort) {
      this.search.order_by = field ? `${field} ${sort}` : ''
      this.handelSearch()
    },
    getData: async function () {
      this.loading = true
      if (!this.$refs.search) {
        return;
      }
      const params = {...this.search, ...this.$refs.search.getSearch()}
      // 获取锁定列表
      const {model} = await liveGuaranteeLockGetLastLock();
      this.lockInfo = model;
      // 获取列表
      const {model: {data, total}} = await liveGuaranteeList(params)
      this.loading = false
      this.search.total = total || 0
      this.table = data || []
    },
    selectable: function (row) {
      return !(row.date_check !== null && this.lockInfo.lock_at >= row.date_check)
    }
  }
}
</script>
<style lang="scss">
@import "./index";

</style>
